import { Pipe, PipeTransform } from '@angular/core';
import { FormNamingUtil } from '../utils/form-naming.util';

@Pipe({
  name: 'additionalInfoName',
  pure: true
})
export class AdditionalInfoNamePipe implements PipeTransform {
  transform(questionNumber: number): string {
    return FormNamingUtil.getAdditionalInfoName(questionNumber);
  }
}
